export default __webpack_public_path__ + "8ef67ca1e490946a9c1b15cd0510b053.png";